import { render, staticRenderFns } from "./business-consulting-list.vue?vue&type=template&id=6a67bb40&scoped=true&"
import script from "./business-consulting-list.vue?vue&type=script&lang=ts&"
export * from "./business-consulting-list.vue?vue&type=script&lang=ts&"
import style0 from "./business-consulting-list.vue?vue&type=style&index=0&id=6a67bb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67bb40",
  null
  
)

export default component.exports